import { createSelector } from 'reselect';
import get from 'lodash/get';
export var positionSelector = createSelector([function (state) {
  return state.user;
}, function (state) {
  return state.apexCore.position;
}], function (_ref, _ref2) {
  var selectedAccountId = _ref.selectedAccountId;
  var positions = _ref2.positions;
  return get(positions, selectedAccountId, {});
});
export var positionByProductIdSelector = function positionByProductIdSelector(productId) {
  return createSelector(positionSelector, function (positions) {
    if (productId) {
      return positions[productId];
    }
    return {};
  });
};